import { PermissionsTypes } from 'enum/permissionsType'

export interface IModeratorPermissionsModel {
  id?: number
  index: number
  type: PermissionsTypes
  selected?: { value: any; length: number; tooltip: string }
  seeMonitor: boolean
  editCourse: boolean
  manageCourses: boolean
  chat: boolean
  downloadReports: boolean
  approveRequests: boolean
  monitoringAreas: boolean
  _destroy?: boolean
}

export enum ModeratorPermissions {
  seeMonitor = 'seeMonitor',
  editCourse = 'editCourse',
  manageCourses = 'manageCourses',
  chat = 'chat',
  downloadReports = 'downloadReports',
  approveRequests = 'approveRequests',
  monitoringAreas = 'monitoringAreas',
}
